<template>
  <table class="items-center w-full bg-transparent border-collapse">
    <TableHead :headers="['ID', 'Name', 'Description']" />
    <tbody>
      <InstanceTableRow
        v-for="(data, index) in InstanceList.slice(from, to)"
        :key="index"
        :data="data"
        :draftList="DraftList"
        :componentId="componentId"
        :id="index"
      />
    </tbody>
  </table>
  <TableNavigation
    class="mr-4 rounded-b-md"
    :from="from + 1"
    :to="to"
    :total="InstanceList.length"
    :navigate="navigate"
    :itemPerPage="itemPerPage"
    @update:itemPerPage="handleChangeItemNumber"
  />
</template>

<script>
import { mapGetters } from "vuex";
import * as Actions from "@/store/actions.type";
import TableNavigation from "@/components/Shared/Table/TableNavigation";
import TableHead from "@/components/DashboardModule/TableHead";
import InstanceTableRow from "@/components/ComponentModule/InstanceTable/InstanceTableRow";

export default {
  name: "InstanceTable",
  components: {
    TableHead,
    InstanceTableRow,
    TableNavigation
  },
  data() {
    return {
      itemPerPage: 10
    };
  },
  props: {
    InstanceList: {
      type: Array,
      required: true
    },
    DraftList: {
      type: Array,
      require: true
    },
    componentId: {
      type: String,
      require: true
    }
  },
  watch: {
    itemPerPage() {
      this.$store.dispatch(Actions.INSTANCE_SET_PAGE, 0);
    }
  },
  computed: {
    from() {
      const itemPerPage = this.itemPerPage || 10;
      return this.getInstancePage * itemPerPage;
    },
    to() {
      const itemPerPage = this.itemPerPage || 10;
      if ((this.getInstancePage + 1) * itemPerPage < this.InstanceList.length) {
        return this.from + itemPerPage;
      } else {
        return this.InstanceList.length;
      }
    },
    ...mapGetters(["getInstancePage"])
  },
  methods: {
    navigate(step) {
      if (step === "prev" && this.getInstancePage !== 0) {
        this.$store.dispatch(
          Actions.INSTANCE_SET_PAGE,
          this.getInstancePage - 1
        );
      }
      if (
        step === "next" &&
        (this.getInstancePage + 1) * this.itemPerPage < this.InstanceList.length
      ) {
        this.$store.dispatch(
          Actions.INSTANCE_SET_PAGE,
          this.getInstancePage + 1
        );
      }
    },
    handleChangeItemNumber(val) {
      this.itemPerPage = val;
    }
  }
};
</script>
